import Container from "@/components/Container";
import { useEffect } from "preact/hooks";

interface LoadingProductsProps {
  onReady: () => void;
  delay: number;
  loadingText: string;
}

const LoadingProducts = ({
  onReady,
  delay,
  loadingText,
}: LoadingProductsProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onReady();
    }, delay);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container>
      <div className="lc-flex lc-flex-col lc-items-center lc-justify-center lc-h-full lc-gap-5">
        <div className="lc-flex lc-flex-row lc-gap-6 lc-justify-center">
          <span
            className="lc-w-6 lc-h-6 md:lc-w-8 md:lc-h-8 lc-rounded-full lc-bg-blue-primary lc-animate-bounce"
            style="animation-delay: 0s;"
          ></span>
          <span
            className="lc-w-6 lc-h-6 md:lc-w-8 md:lc-h-8 lc-rounded-full lc-bg-blue-primary lc-animate-bounce"
            style="animation-delay: 0.1s;"
          ></span>
          <span
            className="lc-w-6 lc-h-6 md:lc-w-8 md:lc-h-8 lc-rounded-full lc-bg-blue-primary lc-animate-bounce"
            style="animation-delay: 0.2s;"
          ></span>
          <span
            className="lc-w-6 lc-h-6 md:lc-w-8 md:lc-h-8 lc-rounded-full lc-bg-blue-primary lc-animate-bounce"
            style="animation-delay: 0.3s;"
          ></span>
          <span className="lc-sr-only">Loading...</span>
        </div>
        <p className="lc-text-white lc-text-3xl md:lc-text-5xl lc-text-center lc-font-flecha lc-leading-normal">
          {loadingText}
        </p>
      </div>
    </Container>
  );
};

export default LoadingProducts;
